module.exports = __webpack_public_path__ + "static/media/gp_icon.25e098b0.png";